/* tslint:disable */
/* eslint-disable */
/**
 * pricing API
 * Pricing service
 *
 * The version of the OpenAPI document: 38.846.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PricingError
 */
export interface PricingError {
    /**
     * 
     * @type {string}
     * @memberof PricingError
     */
    pricingErrorType?: PricingErrorPricingErrorType;
    /**
     * 
     * @type {string}
     * @memberof PricingError
     */
    message?: string;
}


/**
 * @export
 */
export const PricingErrorPricingErrorType = {
    NOT_FOUND_ACCRUED_INTEREST: 'NOT_FOUND_ACCRUED_INTEREST'
} as const;
export type PricingErrorPricingErrorType = typeof PricingErrorPricingErrorType[keyof typeof PricingErrorPricingErrorType];


/**
 * Check if a given object implements the PricingError interface.
 */
export function instanceOfPricingError(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PricingErrorFromJSON(json: any): PricingError {
    return PricingErrorFromJSONTyped(json, false);
}

export function PricingErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PricingError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pricingErrorType': !exists(json, 'pricingErrorType') ? undefined : json['pricingErrorType'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function PricingErrorToJSON(value?: PricingError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pricingErrorType': value.pricingErrorType,
        'message': value.message,
    };
}

